export const clausesConstants = {
  CREATE_CLAUSES_SUCCESS: "CREATE_CLAUSES_SUCCESS",
  CREATE_CLAUSES_FAILURE: "CREATE_CLAUSES_FAILURE",

  GET_CLAUSES_SUCCESS: "GET_CLAUSES_SUCCESS",
  GET_CLAUSES_FAILURE: "GET_CLAUSES_FAILURE",
};
